import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/es';
export const locale = {
  lang: 'es',
  data: {
    'RAWDATA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Consultar Raw Data',
      'SUBTITULO': 'Consulte la información de la Raw Data de las encuestas generadas en la plataforma en un periodo específico',
      'NOFILE': 'No generada',
      'FILTER': 'Filtrar por empresa o Survey Token',
      'DOWNLOADFILE': 'Descargar archivo',
      'CAMPOS': {
        'anio': 'Año',
        'broker': 'Broker',
        'brokerCountry': 'País del broker',
        'anioRanking': 'Año ranking',
      },
      'COLUMNAS': {
        'nombre': 'Empresa',
        'producto': 'Tipo de producto',
        'surveytoken': 'Survey Token',
        'fecha': 'Fecha',
        'acciones': 'Raw Data',
        'tiporawdata': 'Tipo de Raw Data'
      },
      'RESULTADOS': {
        'CARGANDO': 'Cargando resultados de la búsqueda',
        'TITULO': 'Resultados',
        'ENCONTRADAS': 'Total de encuestas encontradas',
        'DESCARGAR': 'Descargar información en formato Excel',
        'SINRESULTADOS': 'No se encontraron encuestas creadas con los parámetros especificados'
      }
    }
  }
};
